import { createContext, useContext, type ReactNode } from 'react';

const WorkspaceIdentityContext = createContext<{ storeName: string | null }>({ storeName: null });

export function WorkspaceIdentityProvider({ storeName, children }: { storeName?: string | null; children: ReactNode }) {
  return <WorkspaceIdentityContext.Provider value={{ storeName: storeName?.trim() || null }}>{children}</WorkspaceIdentityContext.Provider>;
}

export function useWorkspaceIdentity() {
  return useContext(WorkspaceIdentityContext);
}
